import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

// 🔹 Get last 12 months from current month
const getLast12Months = () => {
  const result = [];
  const now = new Date();

  for (let i = 11; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    result.push({
      label: d.toLocaleString("default", { month: "short", year: "numeric" }),
      month: d.getMonth() + 1,
      year: d.getFullYear(),
    });
  }

  return result;
};

const MonthlyLeadConversion = ({ apiData = [] }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const months = getLast12Months();

    // 🔹 Map API data to last 12 months
    const values = months.map(m => {
      const found = apiData.find(
        d => Number(d.month) === Number(m.month) && Number(d.year) === Number(m.year)
      );
      return found ? (Number(found.total) || 0) : 0;
    });

    setChartData({
      labels: months.map(m => m.label),
      datasets: [
        {
          label: "Leads Converted",
          data: values,
          backgroundColor: [
            "#4bc0c0", "#36a2eb", "#ffce56", "#9966ff",
            "#ff9f40", "#ff6384", "#4bc0c0", "#36a2eb",
            "#ffce56", "#9966ff", "#ff9f40", "#ff6384"
          ],
          borderRadius: 6,
          barThickness: 28
        }
      ]
    });
  }, [apiData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 1 }
      }
    }
  };

  return (
    <div className="col-xl-6">
      <div className="card pending-app overflow-hidden mt-2 mb-4 pr-2">
        <div className="card-body p-3">
          <h4 className="mb-3">
            <img
              src={`${process.env.PUBLIC_URL || ""}/assets/images/icon2.png`}
              alt=""
              style={{ marginRight: 5 }}
            />
            Monthly Lead Conversion
          </h4>

          <div style={{ height: 300 }}>
            {chartData && <Bar data={chartData} options={options} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyLeadConversion;
